import { useQuery } from 'react-query';
import { useEffect } from 'react';
import { apiClient } from '../../services/ApiClient';
import { type Settings } from '../../components/Map/types';
import { ActionType } from '../../components/GlobalContextProvider/global-reducer';
import { useDispatch } from '../../components/GlobalContextProvider/GlobalContextProvider';
import { ApiEndpoints } from '../../constants/api-constants';
import { Queries, QueryCacheConfig } from '../../constants/query-constants';

export const useSettingsQuery = (): void => {
  const mapDispatch = useDispatch();

  const getSettings = async (): Promise<Settings> => {
    return apiClient.get<Settings>(ApiEndpoints.settings);
  };

  const { data, isLoading } = useQuery({
    ...QueryCacheConfig[Queries.Settings],
    queryKey: Queries.Settings,
    queryFn: getSettings,
  });

  useEffect(() => {
    if (!isLoading) {
      mapDispatch({ type: ActionType.UPDATE_SETTINGS, payload: data });
    }
  }, [data, isLoading]);
};
